export const USER_CONTRACT_STATUS = [
  { label: 'Chưa có hợp đồng', value: 0, key: 'UNKNOWN', className: 'status-pending' },
  { label: 'Có hiệu lực', value: 1, key: 'ACTIVE', className: 'status-success' },
  { label: 'Hết hiệu lực', value: 2, key: 'EXPIRED', className: 'status-error' },
];
